const GraphAdminApi = require("./GraphAdminApi");

module.exports = GraphAdminApi;